import type {
  IconGlyph,
  IconStyle,
} from '@ipfabric/ui-components/Icon/IconGlyph';
import classNames from 'classnames';
import type { FC } from 'react';
import type { ButtonSize } from './Button';

interface Props {
  icon?: IconGlyph;
  loading?: boolean;
  size?: ButtonSize;
  style?: IconStyle;
}

export const ButtonIcon: FC<Props> = ({
  icon,
  loading,
  size,
  style = 'regular',
}) => (
  <>
    {icon && !loading && (
      <i
        className={classNames(
          'button__fa',
          size ? `button__fa--${size}` : 'button__fa--xs',
          `fa-${style}`,
          'fa-fw',
          icon,
        )}
      />
    )}
    {loading && (
      <i
        className={classNames(
          'fa-regular fa-spin button__fa',
          size ? `button__fa--${size}` : 'button__fa--xs',
          'fa-spinner',
          'fa-fw',
        )}
      />
    )}
  </>
);
